<template>

  <div>
    <div class="card mb-2">
      <div class="card-body">
        <div class="d-flex align-items-top">
          <div class="mr-3">
            <i class="far fa-file text-muted" style="font-size: 40px"></i>
          </div>
          <div class="flex-grow-1">
            <h5 class="card-title">Requisição em branco</h5>
            <p class="card-text">Inicie uma requisição do zero.</p>
            <button type="button" class="btn btn-primary" @click="set({})">Iniciar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-2">
      <div class="card-body">
        <div class="d-flex align-items-top">
          <div class="mr-3">
            <i class="far fa-copy text-muted" style="font-size: 40px"></i>
          </div>
          <div class="flex-grow-1">
            <h5 class="card-title">A partir de um template</h5>
            <p class="card-text">Use dados de um template para iniciar.</p>
            <SelectRequisition
              class="mb-2"
              @object="set"
              :limit="10"
              :template="true"
              :showStatus="false">
              </SelectRequisition>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import SelectRequisition from '@/components/Fields/SelectRequisition'

export default {
  name: 'RequisitionPreset',
  components: {
    SelectRequisition
  },
  props: [
  ],
  data () {
    return {
      keywords: null,
      requisitions: []
    }
  },
  computed: {
  },
  methods: {
    set (data) {
      this.$emit('input', {
        ...data,
        _id: undefined
      })
    },
    searchData (keywords) {
      if (keywords) {
        this.$store
        .dispatch('getRequisitions', {
          title: '~' + keywords,
          limit: 10
        })
        .then(result => {
          this.keywords = keywords
          this.requisitions = result.docs
        })
      } else {
        this.keywords = null
        this.requisitions = []
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RequisitionForm/RequisitionPreset.vue